/*
 * Global Tagalys SDK loader utility. Injects the third-party Tagalys <script src>
 * on demand and dedupes it — every consumer (search results PLP, mini-search
 * drawer) calls this instead of writing its own <script> tag, so the SDK is
 * never loaded twice regardless of which surface asks for it first. Loaded
 * ONCE in layout/theme.liquid — never per-section (invariant 8, mirrors
 * focus-trap.js).
 *
 *   window.ensureTagalysSdk(url, function () { ... }); // cb fires once window.Tagalys is ready
 *
 * Callers may invoke this eagerly (page load) or lazily (first user
 * interaction) — dedup is keyed on the script's src, not on caller timing.
 */
(function () {
  if (window.ensureTagalysSdk) return;

  var loaded    = false;
  var loading   = false;
  var callbacks = [];

  window.ensureTagalysSdk = function (url, cb) {
    if (loaded || window.Tagalys) { loaded = true; return cb(); }
    callbacks.push(cb);
    if (loading) return;
    loading = true;
    if (!url) { loaded = true; callbacks.forEach(function (f) { f(); }); return; }
    var script = document.querySelector('script[src="' + url + '"]') || document.createElement('script');
    if (!script.parentNode) {
      script.src = url;
      script.defer = true;
      document.head.appendChild(script);
    }
    script.addEventListener('load', function () {
      loaded = true;
      callbacks.forEach(function (f) { f(); });
    });
  };

  var consentReplay = null;
  var apiLoadReplayed = false;

  function replayConfiguration() {
    if (!consentReplay || typeof window.Tagalys === 'undefined') return;
    try { consentReplay(); }
    catch (e) { console.error('[Tagalys Consent] re-configure threw', e); }
  }

  window.TagalysConsent = {
    onChange: function (fn) { if (typeof fn === 'function') consentReplay = fn; }
  };

  document.addEventListener('visitorConsentCollected', replayConfiguration);

  function loadConsentApi() {
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return false;
    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function (error) {
        if (error) { console.error('[Tagalys Consent] consent-tracking-api failed to load', error); return; }
        if (apiLoadReplayed) return;
        apiLoadReplayed = true;
        replayConfiguration();
      }
    );
    return true;
  }

  if (!loadConsentApi()) {
    document.addEventListener('DOMContentLoaded', loadConsentApi, { once: true });
  }
})();
